import { Box, Paper, Typography } from "@mui/material";
import React from "react";

export default function Home() {

    return (
        <>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                background: "linear-gradient(to top, #6EC6FF, #B3E5FC)",
                p: 2
            }}>
                {/* LOGO */}
                <Box sx={{ textAlign: "center", mb: 2 }}>
                    <img src="https://krushi-india.webito.cloud/public/images/banner/SCA.png" alt="Krushi India Logo" width={250} />
                </Box>

                {/* FORM CONTAINER */}
                <Paper elevation={3} sx={{ p: 4, maxWidth: 700, width: "100%" }}>
                    <center><h2>Thank you for your interest</h2></center>

                </Paper>
            </Box>
        </>
    );
}
